import { toast } from "react-toastify";

export const showErrors = (error) => {
  if (typeof error === "object") {
    if (error?.data && Array.isArray(error.data)) {
      error.data.forEach((err) => toast.error(err.msg || err.message));
    } else toast.error(error.message);
  } else toast.error(error);
};
